export default "__VITE_ASSET__DeoyLCl2__"